import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { NoddiButton, NoddiDialog } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { tracking } from 'noddi-web';
import { useNavigate } from 'react-router-dom';
import { ApiErrorMessageWithTrans } from '../Error/ApiErrorMessageWithTrans';

type Props = {
  open: boolean;
  onClose: () => void;
  onRejected?: () => void;
  id: number;
};

export const RejectModal = ({ open, onClose, onRejected, id }: Props) => {
  const navigate = useNavigate();

  const {
    mutate: cancelBooking,
    isPending: isCancelling,
    error
  } = noddiAsync.usePatch({
    type: URLKeys.patchRejectBookingProposal,
    queryConfig: {
      onSuccess: () => {
        tracking.track('autoRecallCancelBooking');
        onRejected?.();
        if (!onRejected) {
          navigate(customerRoutes.cancelledBooking.getPath());
        }
      }
    }
  });

  return (
    <NoddiDialog
      title={t`Cancel your booking`}
      onClose={onClose}
      open={open}
      footer={
        <div className='flex flex-col gap-4'>
          {error && <ApiErrorMessageWithTrans error={error} />}
          <div className='flex flex-wrap gap-2'>
            <NoddiButton onClick={onClose} loading={isCancelling} className='flex-1' variant='outline'>
              <Trans>Cancel</Trans>
            </NoddiButton>
            <NoddiButton
              onClick={() => cancelBooking({ bookingProposalId: id })}
              loading={isCancelling}
              startIcon='X'
              className='flex-1'
              variant='destructive'
            >
              <Trans>Cancel booking</Trans>
            </NoddiButton>
          </div>
        </div>
      }
    >
      <span>
        <Trans>
          If you don't want to use your prepared booking this season, please cancel it. This way, we won't send you any
          further reminders.
        </Trans>
      </span>
    </NoddiDialog>
  );
};
